import React from 'react';
export function CTA() {
  return <section className="py-16 md:py-20 bg-blue-600" data-id="element-31">
      <div className="container mx-auto px-4" data-id="element-32">
        <div className="max-w-4xl mx-auto text-center" data-id="element-33">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-34">
            Ready to Start Your U.S. Business Journey?
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-35">
            Get your ITIN today and save $50 with our exclusive discount code
            "Super Neil"
          </p>
          <div className="bg-white rounded-lg p-6 md:p-8 shadow-lg mb-8" data-id="element-36">
            <div className="text-center mb-4" data-id="element-37">
              <span className="text-lg font-semibold text-gray-900" data-id="element-38">
                Your Exclusive Discount Code:
              </span>
            </div>
            <div className="bg-gray-100 border-2 border-dashed border-gray-300 rounded-md p-4 mb-6" data-id="element-39">
              <span className="text-2xl font-bold text-blue-600 tracking-wider" data-id="element-40">
                SUPER NEIL
              </span>
            </div>
            <p className="text-gray-600 text-sm mb-6" data-id="element-41">
              Enter this code during checkout at TheITIN.com to receive $50 off
              your ITIN application service.
            </p>
            <a href="https://theitin.com/ref/598/" target="_blank" rel="noopener noreferrer" className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-md font-medium inline-block transition-colors" data-id="element-42">
              Claim Your Discount Now
            </a>
          </div>
          <p className="text-blue-100 text-sm" data-id="element-43">
            Limited time offer. Don't miss out on this exclusive discount from
            SuperNeil.com!
          </p>
        </div>
      </div>
    </section>;
}